import NoPhotoCouple from "./Theme1/NoPhotoCouple";
import PhotoCouple from "./Theme1/PhotoCouple";
import Theme2Nophotocouple from "./Theme2/Theme2Nophotocouple";
import Theme2Photocouple from "./Theme2/Theme2Photocouple";
import Theme3Nophotocouple from "./Theme3/Theme3Nophotocouple";
import Theme3Photocouple from "./Theme3/Theme3Photocouple";
import Theme4Nophotocouple from "./Theme4/Theme4Nophotocouple";
import Theme4Photocouple from "./Theme4/Theme4Photocouple";
import Theme5Nophotocouple from "./Theme5/Theme5Nophotocouple";
import Theme5PhotoCouple from "./Theme5/Theme5PhotoCouple";


const CouplePreview = ({ values, theme }) => {

  if (theme === "theme1") {
    return values.coupleType === "photoCouple"
      ? <PhotoCouple values={values} />
      : <NoPhotoCouple values={values}/>
  }

   if (theme === "theme2") {
    return values.coupleType === "photoCouple"
      ? <Theme2Photocouple values={values} />
      : <Theme2Nophotocouple values={values}/>
  }

    if (theme === "theme3") {
    return values.coupleType === "photoCouple"
      ? <Theme3Photocouple values={values} />
      : <Theme3Nophotocouple values={values}/>
  }


    if (theme === "theme4") {
    return values.coupleType === "photoCouple"
      ? <Theme4Photocouple values={values} />
      : <Theme4Nophotocouple values={values}/>
  }

     if (theme === "theme5") {
    return values.coupleType === "photoCouple"
      ? <Theme5PhotoCouple values={values} />
      : <Theme5Nophotocouple values={values}/>
  }

  return null;
};

export default CouplePreview;